import React from 'react';
import classNames from 'classnames';
import { formatDateTime } from '../../../utils/date-utils';
import DocumentAttachments from './DocumentAttachments';
import DocumentLink from './DocumentLink';

const getColumns = ({
  id,
  type,
  fileName,
  title,
  attachments,
  isNew,
  isUpdated,
  updating,
  loading,
  audit: { updateDateTime },
}) => [(
  <DocumentLink
    key="col1"
    external={type === 'LINK'}
    to={type === 'LINK' ? fileName : '/documents/' + id}
    disabled={loading}
    className="col1">
    {isNew && (
      <div className="col-sup">
        <div className="label label-rose">New</div>
      </div>
    )}
    {!isNew && isUpdated && !updating && (
      <div className="col-sup">
        <span className="ic ic-2x ic-lap ic-rose"/>
      </div>
    )}
    <div className="col-main">
      <span>
        {title}
      </span>
      {isUpdated && !updating && (
        <span className="maj">Mise à jour le {formatDateTime(updateDateTime)}</span>
      )}
    </div>
  </DocumentLink>
), (
  <DocumentAttachments
    key="col3"
    documentId={id}
    attachments={attachments}
  />
)];

/**
 * Component displaying a table row representing a document.
 */
const DocumentEntry = ({ document, style }) => {
  const columns = getColumns(document);

  if (document.loading) {
    return (
      <div className="encart-table-line disabled" style={style}>
        {columns}
      </div>
    );
  }

  return (
    <div
      className={classNames('encart-table-line', {
        'high-priority': document.highPriority,
      })}
      style={style}
    >
      {columns}
    </div>
  );
};

export default DocumentEntry;



// WEBPACK FOOTER //
// ./book/src/commons/components/document/table/DocumentEntry.jsx